import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PricingPage } from './PricingPage'
import { FlatRatePricingPage } from './FlatRatePricingPage'
import { ZipFlatRatePricingPage } from './ZipFlatRatePricingPage'
import { DeadheadFeesPage } from './DeadheadFeesPage'
import { useSettingsTab } from './useSettingsTab'

export function PricingSettingsPage() {
  const [tab, setTab] = useSettingsTab('pricing')

  return (
    <Tabs value={tab} onValueChange={setTab} className="space-y-4">
      <TabsList>
        <TabsTrigger value="pricing">Pricing</TabsTrigger>
        <TabsTrigger value="flat-rates">Flat Rates</TabsTrigger>
        <TabsTrigger value="zip-flat-rates">ZIP Flat Rates</TabsTrigger>
        <TabsTrigger value="deadhead-fees">Deadhead Fees</TabsTrigger>
      </TabsList>

      <TabsContent value="pricing">
        <PricingPage />
      </TabsContent>

      <TabsContent value="flat-rates">
        <FlatRatePricingPage />
      </TabsContent>

      <TabsContent value="zip-flat-rates">
        <ZipFlatRatePricingPage />
      </TabsContent>

      <TabsContent value="deadhead-fees">
        <DeadheadFeesPage />
      </TabsContent>
    </Tabs>
  )
}
